<template>
  <div class="signup-enter-code">
    <riseup-header/>
    <cookies-disabled-error v-if="cookiesDisabledError" />
    <member-already-exists-error v-else-if="memberAlreadyExists" :phoneNumber="phoneNumber" />
    <enter-code v-else class="enter-code" :first-name="firstName"
                      :phone-number="phoneNumber"
                      :confirm-code-action="validateCodeClicked"
                      :regenerate-code-action="generateCode"
                      :server-error="serverErrors.validateCode"
                      :button-title="'אישור'"
                      :loading="loading"
                      :reset-error="() => resetError('validateCode')"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Segment from '../../../../../../Segment';
import EnterCode from '../../../../../../base-components/EnterCode.vue';
import MemberAlreadyExistsError from '../../../../../general-errors/MemberAlreadyExistsError.vue';
import CookiesDisabledError from '../../../../../general-errors/CookiesDisabledError.vue';
import RiseupHeader from '../../../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'SignupEnterCode',
  components: {
    EnterCode,
    MemberAlreadyExistsError,
    CookiesDisabledError,
    RiseupHeader,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('SignupCodeEntered');
  },
  computed: {
    ...mapState('signup', ['firstName', 'phoneNumber', 'serverErrors']),
    ...mapGetters('signup', ['errorTypes', 'amplitudeUtmParams']),
    memberAlreadyExists() {
      return this.serverErrors.createCustomer === this.errorTypes.memberAlreadyExists;
    },
    cookiesDisabledError() {
      return this.serverErrors.validateCode === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapActions('signup', ['validateCode', 'generateCode', 'createCustomer']),
    ...mapMutations('signup', ['resetError']),
    ...mapActions('session', ['init']),
    async validateCodeClicked(code) {
      Segment.trackUserInteraction('CodeEnteredClicked');
      Segment.trackUserInteractionToPixel('CodeEnteredClicked');
      this.loading = true;
      try {
        await this.validateCode(code);
        if (!this.serverErrors.validateCode) {
          await this.createCustomerAndSession();
          this.next();
        } else if (this.memberAlreadyExists) {
          Segment.trackUserGot('SignupEnterCode_MemberAlreadyExists');
        } else if (this.cookiesDisabledError) {
          Segment.trackUserGot('SignupEnterCode_CookiesDisabledError');
        }
      } finally {
        this.loading = false;
      }
    },
    async identifyCustomer(customerId) {
      Segment.identifyCustomer(customerId, {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        ...this.amplitudeUtmParams,
      });
    },
    async createCustomerAndSession() {
      const { data: { customerId } } = await this.createCustomer();
      await this.identifyCustomer(customerId);
      Segment.trackUserGotToPixel('CCC');
      await this.init({});
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '../../../../../../scss/mixins';

  .signup-enter-code {
    @include white-page-frame;
    height: 100%;

    .enter-code {
      @include responsive-padding;
      width: 100%;
    }
  }

</style>
